const FEISHU_USER_AGENT = /(?:Feishu|Lark(?:\/|WebView|Locale|\s|$))/i

export function isFeishuClient(search: string, userAgent: string) {
  const source = new URLSearchParams(search).get('source')?.trim().toLowerCase()
  return source === 'feishu' || source === 'lark' || FEISHU_USER_AGENT.test(userAgent)
}
